Foundation.Mobile.Panel = function (el) {
    this.element = jQuery(el);
    this.document = jQuery(document);

    if (this.element.hasClass('ui-position-right')) {
        this.options['position'] = "right";
    }
    this._create();
}

Foundation.Mobile.Panel.closeAll = function () {
    var panels = Foundation.Mobile.instance.panel_views;
    for (var i = 0; i < panels.length; i++) {
        panels[i].close();
    }
}

var compensateToolbars  = function () {

}


jQuery.extend(Foundation.Mobile.Panel.prototype, {
    options: {
        classes: {
            panel: "panel",
            panelOpen: "open",
            panelClosed: "closed",
            panelFixed: "fixed",
            panelInner: "inner",
            modal: "ui dismiss",
            modalOpen: "open",
            pageContainer: "page",
            pageWrapper: "page",
            panelWrapper: "ui-panel-wrapper",
            pageFixedToolbar: "ui-panel-fixed-toolbar",
            pageContentPrefix: "ui-panel-page-content", /* Used for wrapper and fixed toolbars position, display and open classes. */
            animate: "animate"
        },
        animate: true,
        theme: null,
        position: "left",
        dismissible: true,
        display: "overlay", //accepts reveal, push, overlay
        swipeClose: true,
        positionFixed: false
    },

    _closeLink: null,
    _parentPage: null,
    _page: null,
    _modal: null,
    _panelInner: null,
    _wrapper: null,
    _fixedToolbars: null,

    _create: function () {
        var el = this.element,
        parentPage = el.closest( "body" );

        // expose some private props to other methods
        jQuery.extend( this, {
            _closeLink: parentPage.find( ".close" ),
            _parentPage: ( parentPage.length > 0 ) ? parentPage : false,
            _openedPage: null,
            _page: this._getPage,
            _panelInner: this._getPanelInner(),
            _fixedToolbars: this._getFixedToolbars
        });
        //if ( this.options.display !== "overlay" ){
        this._getWrapper();
        this._getPanelWrapper();
        this._getPanel();
        //}
        this._addPanelClasses();

        // if animating, add the class to do so
        if ( jQuery.support.cssTransform3d && !!this.options.animate ) {
            this.element.addClass( this.options.classes.animate );
        }

        this._bindUpdateLayout();
        this._bindCloseEvents();
        this._bindLinkListeners();
        this._bindPageEvents();

        if ( this.options.dismissible ) {
            this._createModal();
        }

        this._bindSwipeEvents();
    },

    _getPanel: function () {
        this._panelWrapper.append(this.element.remove());
    },

    _getPanelInner: function () {
        var panelInner = this.element.find( `.${this.options.classes.panelInner}` );

        if ( panelInner.length === 0 ) {
            panelInner = this.element.children().wrapAll( `<div class='${this.options.classes.panelInner}' />` ).parent();
        }

        return panelInner;
    },

    /*
     * Creates the dismiss div
     */
    _createModal: function () {
        var self = this,
        target = self._panelWrapper;

        self._modal = jQuery( `<div class='${self.options.classes.modal}'></div>` )
        .on( "mousedown", function () {
            self.close();
        })
        .appendTo( target );
    },

    _getPage: function () {
        var page = jQuery('.page');

        return page;
    },

    _getPanelWrapper: function () {
        var wrapper = this._page().siblings( `.${this.options.classes.panelWrapper}` );
        if ( wrapper.length === 0 ) {
            wrapper = jQuery( `<div class='${this.options.classes.panelWrapper}'></div>` );
            this._page().after(wrapper );
        }

        this._panelWrapper = wrapper;
    },

    _getWrapper: function () {
        var wrapper = this._page().children().find( `.${this.options.classes.pageWrapper}` );
        if ( wrapper.length === 0 ) {
            wrapper = this._page().children( ".ui-header:not(.ui-header-fixed), .ui-content:not(.ui-popup), .ui-footer:not(.ui-footer-fixed)" )
            .wrapAll( `<div class='${this.options.classes.pageWrapper}'></div>` )
            .parent();
        }

        this._wrapper = wrapper;
    },

    /* xxx: this is functionality that will need to be re-added */
    /*    _getFixedToolbars: function() {*/
    //var extFixedToolbars = jQuery( "body" ).children( ".ui-header-fixed, .ui-footer-fixed" ),
    //intFixedToolbars = this._page().find( ".ui-header-fixed, .ui-footer-fixed" ),
    //fixedToolbars = extFixedToolbars.add( intFixedToolbars ).addClass( this.options.classes.pageFixedToolbar );

    //return fixedToolbars;
    /*},*/

    _refresh: function () {
        const self = this;
        var height = Math.max( this._panelInner.outerHeight(), jQuery('body').height());
        self._modal.height( height );
    },

    _getPosDisplayClasses: function () {
        return this.options.position + this.options.display;
    },

    _getPanelClasses: function () {
        /*
        var panelClasses = this.options.classes.panel +
            " " + this._getPosDisplayClasses( this.options.classes.panel ) +
            " " + this.options.classes.panelClosed;

        if ( !!this.options.positionFixed ) {
            panelClasses += " " + this.options.classes.panelFixed;
        }
        */

        return 'closed';
    },

    _addPanelClasses: function () {
        this.element.addClass( this._getPanelClasses() );
/*
        this.element.addClass('closed');
            self.element
                .removeClass( o.classes.panelClosed )
                .addClass( o.classes.panelOpen );
                */
    },

    _handleCloseClickAndEatEvent: function ( event ) {
        if ( !event.isDefaultPrevented() ) {
            event.preventDefault();
            this.close();
            return false;
        }
    },

    _handleCloseClick: function ( event ) {
        if ( !event.isDefaultPrevented() ) {
            this.close();
        }
    },

    _bindCloseEvents: function () {
        this._closeLink.on("click", this._handleCloseClick.bind(this));
    },

    _positionPanel: function ( scrollToTop ) {
        var self = this,
        panelInnerHeight = self._panelInner.outerHeight(),
        expand = panelInnerHeight > jQuery(window).height();



        this._panelWrapper.height(jQuery('body').height());

        if ( expand || !self.options.positionFixed ) {
            if ( expand ) {
                self._unfixPanel();
                //jQuery.mobile.resetActivePageHeight( panelInnerHeight );
            }
            if ( scrollToTop ) {
                jQuery(window)[0].scrollTo( 0, 1 );
            }
        }
        else {
            self._fixPanel();
        }
    },

    _resetActivePageHeight: function (height) {
        var page = jQuery( `.${jQuery.mobile.activePageClass}` ),
        pageHeight = page.height(),
        pageOuterHeight = page.outerHeight( true );

        height = compensateToolbars( page,
                                    ( typeof height === "number" ) ? height : jQuery.mobile.getScreenHeight() );

                                    page.css( "min-height", height - ( pageOuterHeight - pageHeight ) );
    },

    _bindFixListener: function () {
        jQuery(window).on('smartresize.panel', this._positionPanel.bind(this));
    },

    _unbindFixListener: function () {
        // xx add uid to event for easy removal
        jQuery(window).off('smartresize.panel');
    },

    _unfixPanel: function () {
        if ( !!this.options.positionFixed && jQuery.support.fixedPosition ) {
            this.element.removeClass( this.options.classes.panelFixed );
        }
    },

    _fixPanel: function () {
        if ( !!this.options.positionFixed && jQuery.support.fixedPosition ) {
            this.element.addClass( this.options.classes.panelFixed );
        }
    },

    _bindUpdateLayout: function () {
        var self = this;

        self.element.on( "updatelayout", function (/* e */) {
            if ( self._open ) {
                self._positionPanel();
            }
        });
    },

    _bindLinkListeners: function () {
        jQuery('body').on('click', 'a', this._handleClick.bind(this));
    },

    _handleClick: function ( e ) {
        // can probably avoid binding to all body link elements :}
        var link,
        panelId = this.element.attr( "id" );

        if ( e.currentTarget.href.split( "#" )[ 1 ] === panelId && panelId !== undefined ) {
            e.preventDefault();
            link = jQuery( e.target );
            if ( link.hasClass( "ui-btn" ) ) {
                link.addClass( jQuery.mobile.activeBtnClass );
                this.element.one( "panelopen panelclose", function () {
                    link.removeClass( jQuery.mobile.activeBtnClass );
                });
            }
            this.toggle();
            return false;
        }
    },

    _bindSwipeEvents: function () {
        var self = this,
        area = self._modal ? self.element.add( self._modal ) : self.element;

        // on swipe, close the panel
        if ( self.options.swipeClose ) {
            if ( self.options.position === "left" ) {
                area.on( "swipeleft.panel", function (/* e */) {
                    self.close();
                });
            }
            else {
                area.on( "swiperight.panel", function (/* e */) {
                    self.close();
                });
            }
        }
    },

    _bindPageEvents: function () {
        var self = this;

        this.document
        // Close the panel if another panel on the page opens
        .on( "panelbeforeopen", function ( e ) {
            if ( self._open && e.target !== self.element[ 0 ] ) {
                self.close();
            }
        })
        // On escape, close? might need to have a target check too...
        .on( "keyup.panel", function ( e ) {
            if ( e.keyCode === 27 && self._open ) {
                self.close();
            }
        });
    },

    // state storage of open or closed
    _open: false,
    _pageContentOpenClasses: null,
    _modalOpenClasses: null,

    open: function ( immediate ) {
        if ( !this._open ) {
            var self = this,
            o = self.options,

            _openPanel = function () {
                self.document.off( "panelclose" );
                //self._page().jqmData( "panel", "open" );
                //
                //
                self._panelWrapper.addClass('active');

                if ( jQuery.support.cssTransform3d && !!o.animate && o.display !== "overlay" ) {
                    self._wrapper.addClass( o.classes.animate );
                    self._fixedToolbars().addClass( o.classes.animate );
                }

                if ( !immediate && jQuery.support.cssTransform3d && !!o.animate ) {
                    self.element.animationComplete( complete, "transition" );
                }
                else {
                    setTimeout( complete, 0 );
                }

                if ( o.theme && o.display !== "overlay" ) {
                    self._page().parent()
                    .addClass( `${o.classes.pageContainer}-themed ${o.classes.pageContainer}-${o.theme}` );
                }

                self.element
                .removeClass( o.classes.panelClosed )
                .addClass( o.classes.panelOpen );

                self._positionPanel( true );

                self._pageContentOpenClasses = self._getPosDisplayClasses( o.classes.pageContentPrefix );

                if ( o.display !== "overlay" ) {
                    self._page().parent().addClass( o.classes.pageContainer );
                    self._wrapper.addClass( self._pageContentOpenClasses );
                    self._fixedToolbars().addClass( self._pageContentOpenClasses );
                }

                self._modalOpenClasses = `${self._getPosDisplayClasses( o.classes.modal )} ${o.classes.modalOpen}`;
                if ( self._modal ) {
                    self._modal
                    .addClass( self._modalOpenClasses )
                    .height( Math.max( self._modal.height(), self.document.height() ) );
                }
            },
            complete = function () {
                if ( o.display !== "overlay" ) {
                    self._wrapper.addClass( `${o.classes.pageContentPrefix}-open` );
                    self._fixedToolbars().addClass( `${o.classes.pageContentPrefix}-open` );
                }

                self._bindFixListener();

                //self._trigger( "open" );

                self._openedPage = self._page();
            };

            //self._trigger( "beforeopen" );
            /*
               if ( self._page().jqmData( "panel" ) === "open" ) {
               self.document.on( "panelclose", function() {
               _openPanel();
               });
               } else {
               */
            _openPanel();
            /*
               }
               */

            self._open = true;
        }
    },

    close: function ( immediate ) {
        if ( this._open ) {
            var self = this,
            o = this.options,

            _closePanel = function () {
                self.element.removeClass( o.classes.panelOpen );

                if ( o.display !== "overlay" ) {
                    self._wrapper.removeClass( self._pageContentOpenClasses );
                    self._fixedToolbars().removeClass( self._pageContentOpenClasses );
                }

                if ( !immediate && jQuery.support.cssTransform3d && !!o.animate ) {
                    self.element.animationComplete( complete, "transition" );
                }
                else {
                    setTimeout( complete, 0 );
                }

                if ( self._modal ) {
                    self._modal.removeClass( self._modalOpenClasses );
                }
            },
            complete = function () {
                if ( o.theme && o.display !== "overlay" ) {
                    self._page().parent().removeClass( `${o.classes.pageContainer}-themed ${o.classes.pageContainer}-${o.theme}` );
                }

                self.element.addClass( o.classes.panelClosed );

                if ( o.display !== "overlay" ) {
                    self._page().parent().removeClass( o.classes.pageContainer );
                    self._wrapper.removeClass( `${o.classes.pageContentPrefix}-open` );
                    self._fixedToolbars().removeClass( `${o.classes.pageContentPrefix}-open` );
                }

                if ( jQuery.support.cssTransform3d && !!o.animate && o.display !== "overlay" ) {
                    self._wrapper.removeClass( o.classes.animate );
                    self._fixedToolbars().removeClass( o.classes.animate );
                }

                self._fixPanel();
                self._unbindFixListener();
                //jQuery.mobile.resetActivePageHeight();

                //self._page().jqmRemoveData( "panel" );

                //self._trigger( "close" );

                self._openedPage = null;
                self._panelWrapper.removeClass('active');
            };

            //self._trigger( "beforeclose" );

            _closePanel();

            self._open = false;
        }
    },

    toggle: function () {
        this[ this._open ? "close" : "open" ]();
    },

    _destroy: function () {
        var otherPanels,
        o = this.options,
        multiplePanels = ( jQuery( "body > :mobile-panel" ).length + jQuery.mobile.activePage.find( ":mobile-panel" ).length ) > 1;

        if ( o.display !== "overlay" ) {
            //  remove the wrapper if not in use by another panel
            otherPanels = jQuery( "body > :mobile-panel" ).add( jQuery.mobile.activePage.find( ":mobile-panel" ) );
            if ( otherPanels.not( ".ui-panel-display-overlay" ).not( this.element ).length === 0 ) {
                this._wrapper.children().unwrap();
            }

            if ( this._open ) {
                this._fixedToolbars().removeClass( `${o.classes.pageContentPrefix}-open` );

                if ( jQuery.support.cssTransform3d && !!o.animate ) {
                    this._fixedToolbars().removeClass( o.classes.animate );
                }

                this._page().parent().removeClass( o.classes.pageContainer );

                if ( o.theme ) {
                    this._page().parent().removeClass( `${o.classes.pageContainer}-themed ${o.classes.pageContainer}-${o.theme}` );
                }
            }
        }

        if ( !multiplePanels ) {
            this.document.off( "panelopen panelclose" );
        }

        if ( this._open ) {
            this._page().jqmRemoveData( "panel" );
        }

        this._panelInner.children().unwrap();

        this.element
        .removeClass( [ this._getPanelClasses(), o.classes.panelOpen, o.classes.animate ].join( " " ) )
        .off( "swipeleft.panel swiperight.panel" )
        .off( "panelbeforeopen" )
        .off( "panelhide" )
        .off( "keyup.panel" )
        .off( "updatelayout" );

        if ( this._modal ) {
            this._modal.remove();
        }
    }
});


window["Foundation"]["Mobile"]["Panel"] = Foundation.Mobile.Panel;
